import React, { FC, useState } from 'react';

import { ChevronDownIcon } from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '../../../../components/combobox/index';
import { useFormat } from '../../../../hooks/index';
import { toUpperCaseWords } from '../../../../utils/to-uppercase-util.util';

type Month = {
  index: number;
  month: string;
};

type MonthItemsListProps = {
  selectedMonth?: Month | null;
};

const useAllMonths = () => {
  const months = Array.from({ length: 12 }, (_, index) => index);
  const { format } = useFormat();
  const currentYear = new Date().getFullYear();
  return months.map((month) => ({
    month: format(new Date(currentYear, month, 1), 'MMMM'),
    index: month,
  }));
};

const MonthItemsList: FC<MonthItemsListProps> = ({ selectedMonth }) => {
  const allMonth = useAllMonths();
  return (
    <>
      {selectedMonth && (
        <ComboboxOption
          className="text-sm font-normal text-gray-700"
          value={{ month: '', index: null } as unknown as string}
        >
          Reset
        </ComboboxOption>
      )}
      {allMonth.map((month) => (
        <ComboboxOption key={month.month} value={month as unknown as string}>
          <span className="text-sm font-normal text-gray-700">{toUpperCaseWords(month.month)}</span>
        </ComboboxOption>
      ))}
    </>
  );
};

export type MonthComboboxProps = {
  defaultValue?: Month;
  onSelect?: (month: Month) => void;
};

const MonthCombobox: FC<MonthComboboxProps> = ({ onSelect, defaultValue }) => {
  const [selectedMonth, setMonth] = useState<Month | null>(null);
  return (
    <Combobox
      as={'div'}
      className="relative"
      onChange={(e: Month) => {
        setMonth(e);
        onSelect?.(e);
      }}
    >
      <div className="relative">
        <ComboboxInput
          className={'absolute z-0 bg-gray-900'}
          icon={<ChevronDownIcon className="mt-3" />}
          onChange={() => ''}
          placeholder={<AppFormattedMessage id="MONTH" />}
          readOnly
          value={
            toUpperCaseWords(defaultValue?.month) || toUpperCaseWords(selectedMonth?.month) || ''
          }
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="w-full">
        <MonthItemsList selectedMonth={selectedMonth} />
      </ComboboxOptions>
    </Combobox>
  );
};

export default MonthCombobox;
